import React, { RefObject } from "react";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import StoreInfoAndSelection from "./StoreInfoAndSelection";
import AddressSelectionSwitch from "./AddressSelectionSwitch";
import { connect } from "shared/src/stores/storeConnect";
import CustomerStore from "../../../../stores/CustomerStore";
import StoreDataStore from "../../../../stores/StoreDataStore";
import { StoreType } from "../../../../datatypes/Store";

type Props = {
    popoverContainer: any;
    store: StoreType | undefined | null;
    isFsdCustomer: boolean;
    deliveryStores: Array<string>;
};

class StoreSelectionPopover extends React.Component<Props> {
    private storeSelectionOverlayTriggerRef: RefObject<any> = React.createRef();
    constructor(props: Props) {
        super(props);
    }

    getAddressAndStoreSelector() {
        return (
            <AddressSelectionSwitch
                onStoreSelect={() => this.storeSelectionOverlayTriggerRef.current?.hide()}
                store={this.props.store}
                renderInPopover
            />
        );
    }

    getStoreSelector() {
        return (
            <StoreInfoAndSelection
                store={this.props.store}
                inMobileMenu={false}
                onStoreSelect={() => this.storeSelectionOverlayTriggerRef.current?.hide()}
            />
        );
    }

    getOverlay() {
        const popup = this.props.isFsdCustomer ? this.getAddressAndStoreSelector() : this.getStoreSelector();
        return (
            <Popover id="popoverStore" className={"brandbar-popover-store brandbar-popover-store-big"}>
                {popup}
            </Popover>
        );
    }

    render() {
        const store = this.props.store;
        const storeName = store && store.storeDisplayName ? store.storeDisplayName : "";
        const overlay = this.getOverlay();
        const storeId = store?.storeId?.locationNumber;
        const iconClass =
            storeId && (this.props.deliveryStores ?? []).includes(storeId)
                ? "icon-big-delivery-address"
                : "icon-big-location";

        return (
            <div className="brandbar-store">
                <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    ref={this.storeSelectionOverlayTriggerRef}
                    overlay={overlay}
                    container={this.props.popoverContainer}
                    rootClose>
                    <div className="brandbar-store-toggle">
                        <i className={"icon-2x " + iconClass} />
                        <div className="hidden-xs hidden-sm">
                            <p className="brandbar-store-data-selected-store">
                                <FormattedMessage id="EX_GLOBAL_HEADER_SELECTED_STORE" />
                            </p>
                            <p className="brandbar-store-data-name">
                                {storeName}
                                <i className="icon-small-chevron-down" />
                            </p>
                        </div>
                    </div>
                </OverlayTrigger>
            </div>
        );
    }
}

export default connect(
    {
        stores: [
            [
                StoreDataStore,
                (storeData: typeof StoreDataStore) => ({
                    store: storeData.getCurrentStore()
                })
            ],
            [CustomerStore, (store: typeof CustomerStore) => store.getCustomerStoreSelectorSettings()]
        ]
    },
    StoreSelectionPopover
);
